export const TeacherExamsTranslations = {
  EXAMS: {
    es: 'Exámenes',
    en: 'Exams',
    cat: 'Exàmens',
    eus: 'Ekzamenak',
    pt: 'Provas'
  },
  NEW_EXAM: {
    es: 'Nuevo examen',
    en: 'New exam',
    cat: 'Nou examen',
    eus: 'Ekzamen berria',
    pt: 'Prova nova'
  },
  EXAMS_EMPTY: {
    es: 'No tienes exámenes creados',
    en: 'You have no exams created',
    cat: 'No tens exàmens creats',
    eus: 'Ez duzu ekzamen sorturik',
    pt: 'Não tem provas criadas'
  },
  EXAMS_TOTAL_COUNT_one: {
    es: '{{count}} examen',
    en: '{{count}} exam',
    cat: '{{count}} examen',
    eus: '{{count}} ekzamen',
    pt: '{{count}} provas'
  },
  EXAMS_TOTAL_COUNT_other: {
    es: '{{count}} exámenes',
    en: '{{count}} exams',
    cat: '{{count}} exàmens',
    eus: '{{count}} ekzamenak',
    pt: '{{count}} provas'
  },
  TITLE: {
    es: 'Título',
    en: 'Title',
    cat: 'Títol',
    eus: 'Izenburua',
    pt: 'Título'
  },
  DESCRIPTION: {
    es: 'Descripción',
    en: 'Description',
    cat: 'Descripció',
    eus: 'Deskribapena',
    pt: 'Descrição'
  },
  TAG: {
    es: 'Formación',
    en: 'Training',
    cat: 'Formació',
    eus: 'Formazioa',
    pt: 'Formação'
  },
  DATE: {
    es: 'Fecha',
    en: 'Date',
    cat: 'Data',
    eus: 'Data',
    pt: 'Data'
  },
  PROMOTION: {
    es: 'Promoción',
    en: 'Promotion',
    cat: 'Promoció',
    eus: 'Promozioa',
    pt: 'Promoção'
  },
  EDIT_EXAM: {
    es: 'Editar examen',
    en: 'Edit exam',
    cat: 'Editar examen',
    eus: 'Ekzamen aldatu',
    pt: 'Editar prova'
  },
  CREATE_EXAM: {
    es: 'Crear examen',
    en: 'Create exam',
    cat: 'Crear examen',
    eus: 'Ekzamen sortu',
    pt: 'Criar prova'
  },
  CANCEL: {
    es: 'Cancelar',
    en: 'Cancel',
    cat: 'Canelar',
    eus: 'Utzi',
    pt: 'Cancelar'
  },
  SAVE_CHANGES: {
    es: 'Guardar cambios',
    en: 'Save changes',
    cat: 'Guardar canvis',
    eus: 'Aldatu gorde',
    pt: 'Guardar alterações'
  },
  QUIZ: {
    es: 'Test asociado de tipo Simulacro (en el caso de que sea online)',
    en: 'Associated test of Practice type (in case it is online)',
    cat: 'Test associat de tipus Simulacre (en el cas de que sigui online)',
    eus: 'Asociatutako testua mota Simulakro (kasuan online izatean)',
    pt: 'Teste associado de tipo Simulacro (caso seja online)'
  },
  ACTIONS: {
    es: 'Acciones',
    en: 'Actions',
    cat: 'Accions',
    eus: 'Ekintzak',
    pt: 'Ações'
  },
  DELETE_EXAM: {
    es: 'Eliminar examen',
    en: 'Delete exam',
    cat: 'Eliminar examen',
    eus: 'Ekzamen ezabatu',
    pt: 'Eliminar prova'
  },
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_EXAM: {
    es: '¿Estás seguro de que quieres eliminar este examen?',
    en: 'Are you sure you want to remove this exam?',
    cat: 'Estàs segur que vols eliminar aquest examen?',
    eus: 'Zer moduz, ez dago zuzenik?',
    pt: 'Tem certeza que deseja eliminar esta prova?'
  }
};
